import {
    CurrentUserInterface,
    HeaderInterface,
    OfflineDataSourceFieldMappingInterface,
    OfflineDataSourceInterface,
} from "@/interfaces";
import {
    CHANGE_HEADER_TITLE,
    SET_CURRENT_USER_INFO,
    SET_OFFLINE_DATASOURCE_INFO,
    TOGGLE_SIDEBAR,
    UPDATE_OFFLINE_DATASOURCE_FIELD,
    UPDATE_OFFLINE_MAPPING_DATA_SOURCE_VIEW_NEXT_BTN_DATA,
} from "@/redux/types";

export const changeHeaderTitle = (header: HeaderInterface) => ({
    payload: { header },
    type: CHANGE_HEADER_TITLE,
});

export const setCurrentUserInfo = (user: CurrentUserInterface) => ({
    payload: { user },
    type: SET_CURRENT_USER_INFO,
});

export const setOfflineDataSourceInfo = (offlineDataSource: OfflineDataSourceInterface) => ({
    payload: { offlineDataSource },
    type: SET_OFFLINE_DATASOURCE_INFO,
});

export const updateOfflineDataSourceField = (key: string, value: OfflineDataSourceFieldMappingInterface) => ({
    payload: {
        fieldData: {
            key,
            value,
        },
    },
    type: UPDATE_OFFLINE_DATASOURCE_FIELD,
});

export const updateOfflineMappingDataSourceViewNextBtnData = (disabled: boolean, action?: () => void) => ({
    payload: {
        nextBtnData: {
            action,
            disabled,
        },
    },
    type: UPDATE_OFFLINE_MAPPING_DATA_SOURCE_VIEW_NEXT_BTN_DATA,
});

export const toggleSidebar = () => ({
    type: TOGGLE_SIDEBAR,
});
